export const meterToFeet = (altitude?: number) => {
  const feet = 3.2808 * altitude!;
  return Number(feet.toFixed(3));
};

export const feetToMeter = (altitude?: number) => {
  const meter = 0.3048 * altitude!;
  return Number(meter.toFixed(3));
};

export const feetToKilometers = (altitude?: number) => {
  const kilometer = feetToMeter(altitude) / 1000;

  return Number(kilometer.toFixed(3));
};

export const feetToMiles = (altitude?: number) => {
  const miles = altitude! / 5280;
  return Number(miles.toFixed(3));
};

export const getMetricDistanceLabel = (isMeter: boolean) => (isMeter ? 'km' : 'mi');

export const getMetricElevationLabel = (isMeter: boolean) => (isMeter ? 'Elevation (m.)' : 'Elevation (ft.)');
